import { Autocomplete, InputAdornment, TextField } from "@mui/material";
import { forwardRef, MouseEventHandler, useEffect, useRef, useState } from "react";
import { PlusIcon, SearchIcon } from "../../assets/icons";
import theme from "../../theme";

interface IProps {
  input: any;
  placeholder?: string;
  onChange: (event: MouseEvent, newValue: any) => void;
}

const Tagging = forwardRef((props: IProps, ref) => {
  const inputRef = useRef<HTMLInputElement>();
  const [selectionValue, setSelectionValue] = useState<any>(null);
  const [inputValue, setInputValue] = useState("");

  const ingredientType = Boolean(props.input.some((item: any) => item.id && item.name));

  const handleOnchange = (event: any, newValue: any) => {
    event.stopPropagation();
    props.onChange(event, newValue);
    inputRef.current?.focus();
    setInputValue("");
  };

  const handleOnInputChange = (event: React.SyntheticEvent, value: string, reason: string) => {
    setInputValue(value);
  };

  return (
    <Autocomplete
      sx={{
        "& .MuiInputBase-root": { height: "30px", margin: 0, bgcolor: "#fff" },
        "& .MuiAutocomplete-input": {
          paddingTop: "0 !important",
          paddingBottom: "0 !important",
          color: "text.dark2",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 500,
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderRadius: "8px",
          borderColor: "#e5e7ea !important",
        },
        "& .MuiOutlinedInput-root": {
          padding: 0,
          paddingLeft: "3px",
        },
        "& .MuiInputAdornment-root": {
          marginRight: 0,
        },
      }}
      value={selectionValue}
      inputValue={inputValue}
      options={props.input}
      onChange={handleOnchange}
      onInputChange={handleOnInputChange}
      getOptionLabel={(option) => (ingredientType ? String(option.name?.en) : String(option))}
      renderOption={(props, option) => {
        return (
          <li {...props} key={ingredientType ? option.id : option}>
            {ingredientType ? option.name?.en : option}
          </li>
        );
      }}
      renderInput={(params: any) => (
        <TextField
          {...params}
          inputRef={inputRef}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <PlusIcon color={theme.palette.primary.main} />
              </InputAdornment>
            ),
          }}
          placeholder={props.placeholder || "Search"}
        />
      )}
    />
  );
});

export default Tagging;
